import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Loader, TextLink } from "@src/components/atoms";
import CommitmentCard from "@src/components/cards/CommitmentCard";
import FAQList from "@src/pages/sharedSections/FAQList";
import { useDCContext } from "@src/context/dcContext";
import { useOperatorContext } from "@src/context/operatorContext";
import OperatorHooks from "@src/context/hooks/operatorHooks";

const QuickAnswers = () => {
  const { profile, commitment, setOnboardingOpen } = useOperatorContext();
  const {
    countSimilarDynamicReplacements,
    existsDynamicReplacements,
    getDynamicReplacement,
  } = useDCContext();
  const navigate = useNavigate();

  //Customer commitments
  const {
    data: { customerCommitments } = {},
    isPending: commitmentsPending,
    error: commitmentsError,
  } = OperatorHooks.useCustomerCommitments(profile?.operator?.id);

  if (!profile?.customer) return null;
  const { customer } = profile;

  const getFAQs = () => {
    const FAQs = [];
    /** eg. faq__cat1__q1 */
    const pattern = new RegExp(/^faq__cat(\d+)__q(\d+)$/);
    const categoryMap = countSimilarDynamicReplacements(pattern);

    Object.entries(categoryMap).forEach(([cat, maxQ]) => {
      for (let q = 1; q <= maxQ; q++) {
        const key = `faq__cat${cat}__q${q}`;
        if (existsDynamicReplacements(key)) {
          FAQs.push(key);
        }
      }
    });
    if (FAQs.length <= 2) return FAQs;
    const shuffled = [...FAQs].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 2);
  };

  const faqKeys = getFAQs();

  return (
    <div className="sm:col-span-2 lg:col-span-1 flex flex-col sm:flex-row lg:flex-col gap-4 items-center">
      <div className="w-full flex flex-col items-center">
        <h3 className=" font-extrabold mb-4">Quick Answers</h3>
        <FAQList
          getDynamicContentFunc={getDynamicReplacement}
          faqDCKeys={[...faqKeys]}
          eventName={customer.preferredEventName}
          handleOpenOnboarding={() => setOnboardingOpen("support")}
        />

        <TextLink
          side="right"
          to="/dashboard/operator/support"
          onClick={() => navigate("/dashboard/operator/support")}
          text="See more FAQs"
          trackingActionKey="MENU_SELECTION"
        />
      </div>
      <div className="w-full">
        {commitmentsPending ? (
          <div className="min-h-20">
            <div className="w-full h-full flex items-center justify-center">
              <Loader size="xl" />
            </div>
          </div>
        ) : commitmentsError ? (
          <div>Error fetching commitments...</div>
        ) : (
          <>
            {commitment && (
              <CommitmentCard
                commitmentDate={moment
                  .utc(commitment.modifiedAt)
                  .format("D MMM, YYYY")}
                customer={customer}
                customerCommitments={customerCommitments}
                getDynamicContent={getDynamicReplacement}
                userCommitment={commitment.value}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default QuickAnswers;
